import './functions';
import './virtuals';

import { wrapperBuilder } from './build';

export const TargetsAllianzUtilsWrapper = wrapperBuilder.build();
